// eslint-disable-next-line import/prefer-default-export
export const SET_SETTLEMENT_ID = 'SET_SETTLEMENT_ID';
